<template>
  <div class="map-wrap">
    <WizardEventDispatcher :event="'click'" :target="'toggle-katastr'">
      <ToggleSwitch
        v-show="
          (mapLoaded && general.layout.sidebarLeft) ||
          (mapLoaded && general.layout.sidebarRight)
        "
        layout-part="cadastralInfo"
        class="btn--inMap-toggle"
        >Katastr</ToggleSwitch
      >
    </WizardEventDispatcher>

    <WizardEventDispatcher :event="'click'" :target="'button-add-comment-pin'">
      <MapDropdown
        class="btn--inMap btn--dropdown"
        :placeholder="'Přidat komentář do mapy ...'"
        :closeOnOutsideClick="true"
      />
    </WizardEventDispatcher>

    <div class="inmap-switches">
      <WizardEventDispatcher :event="'click'" :target="'toggle-texts'">
        <ToggleSwitch
          v-show="!general.layout.sidebarLeft && !general.layout.sidebarRight"
          layout-part="sidebarRight"
          has-border
          >Texty</ToggleSwitch
        >
      </WizardEventDispatcher>

      <WizardEventDispatcher :event="'click'" :target="'toggle-legend'">
        <ToggleSwitch
          v-show="!general.layout.sidebarLeft && !general.layout.sidebarRight"
          layout-part="sidebarLeft"
          >Legenda</ToggleSwitch
        >
      </WizardEventDispatcher>

      <WizardEventDispatcher :event="'click'" :target="'toggle-katastr'">
        <ToggleSwitch
          v-show="!general.layout.sidebarLeft && !general.layout.sidebarRight"
          has-border-left
          layout-part="cadastralInfo"
          >Katastr</ToggleSwitch
        >
      </WizardEventDispatcher>
    </div>

    <WizardEventDispatcher :event="'click'" :target="'map'">
      <div id="map"></div>
    </WizardEventDispatcher>

    <template v-if="Boolean(this.gmaps.google) && Boolean(this.gmaps.map)">
      <slot :google="gmaps.google" :map="gmaps.map"></slot>
    </template>
  </div>
</template>

<script>
import gmapsInit from '@/services/GMapsInitService';
import ToggleSwitch from '@/components/ToggleSwitch.vue';
import { MAP_SETTINGS } from '@/constants/gmaps.js';
import { mapState, mapActions } from 'vuex';
import CUZKDataService from '@/services/CUZKDataService';
import GeolocationService from '@/services/GeolocationService';
import MapDropdown from '@/components/MapDropdown.vue';
import WizardEventDispatcher from '@/components/wizard/WizardEventDispatcher.vue';

function LocationControl(controlDiv, onClickAction) {
  controlDiv.style.margin = '10px';

  var controlUI = document.createElement('div');
  controlUI.style.backgroundColor = '#fff';
  controlUI.style.border = '2px solid #fff';
  controlUI.style.borderRadius = '2px';
  controlUI.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)';
  controlUI.style.cursor = 'pointer';
  controlUI.style.marginBottom = '22px';
  controlUI.style.textAlign = 'center';
  controlUI.title = 'Click to recenter the map';
  controlDiv.appendChild(controlUI);

  var img = document.createElement('div');
  img.style.backgroundImage =
    'url(https://maps.gstatic.com/tactile/mylocation/mylocation-sprite-1x.png)';
  img.style.margin = '5px';
  img.style.width = '18px';
  img.style.height = '18px';
  controlUI.appendChild(img);

  controlUI.addEventListener('click', function () {
    var x = '0';
    var animationInterval = setInterval(function () {
      if (x == '-18') {
        x = '0';
      } else {
        x = '-18';
      }

      img.style.backgroundPositionX = `${x}px`;
    }, 500);

    onClickAction(() => {
      clearInterval(animationInterval);
      img.style.backgroundPositionX = `0px`;
    });
  });
}

export default {
  async mounted() {
    try {
      this.gmaps.google = await gmapsInit();
      this.initializeMap(MAP_SETTINGS);
      this.initializeInfowindow();
    } catch (error) {
      console.error(error);
    }
  },
  data() {
    return {
      mapLoaded: false,
      watchId: null
    };
  },
  created() {
    if (this.$route.query) {
      let showKatastr = this.$route.query.katastr;
      let mapButtonSelectedLayerId = this.$route.query.mapButtonSelectedLayerId;

      if (mapButtonSelectedLayerId) {
        this.$store.dispatch(
          'general/setMapButtonSelectedLayerId',
          mapButtonSelectedLayerId
        );
      }

      if (showKatastr == '1') {
        this.$store.dispatch('general/setShowCadastralLayer', false);
      }
    }
  },
  components: {
    ToggleSwitch,
    MapDropdown,
    WizardEventDispatcher
  },
  computed: {
    ...mapState(['gmaps', 'threads', 'general', 'layers']),
    ...mapActions(['general/mapClicked', 'general/setInfowindow'])
  },
  methods: {
    updateBaseUrl(query) {
      this.$router.replace({ name: 'base', query: query }).catch((err) => {});
    },
    updateMapCenterInURL() {
      let obj = {
        ...this.$route.query
      };
      let mapCenter = this.gmaps.map.getCenter();

      let params = {
        ...this.$route.params
      };
      params.lat = mapCenter.lat();
      params.lng = mapCenter.lng();
      this.$router
        .replace({ name: 'base', params: params, query: obj })
        .catch((err) => {});
    },
    addCurrentLocationControl() {
      if (document.getElementById('inmap-location-control')) {
        return;
      }

      var locationControlDiv = document.createElement('div');
      locationControlDiv.id = 'inmap-location-control';

      const that = this;
      new LocationControl(locationControlDiv, (cb) => {
        if (that.currentPositionMarker) {
          that.currentPositionMarker.setMap(null);
        }

        GeolocationService.getCurrentPosition()
          .then((response) => {
            that.currentPositionMarker = new that.gmaps.google.maps.Marker({
              draggable: false,
              animation: that.gmaps.google.maps.Animation.DROP,
              position: {
                lat: response.coords.latitude,
                lng: response.coords.longitude
              },
              icon: 'https://sarudoli.axiohm.cz/gm/my_location.png'
            });

            that.currentPositionMarker.setMap(that.gmaps.map);
            that.gmaps.map.setCenter(that.currentPositionMarker.getPosition());
            cb();
          })
          .catch((err) => {
            that.$toasted.show(
              'Nepodařilo se načíst polohu. Opakujte později.',
              {
                type: 'error',
                position: 'top-right',
                duration: '5000'
              }
            );
            cb();
          });
      });

      locationControlDiv.index = 1;
      this.gmaps.map.controls[
        this.gmaps.google.maps.ControlPosition.RIGHT_BOTTOM
      ].push(locationControlDiv);
    },
    removeCurrentLocationControl() {
      if (document.getElementById('inmap-location-control')) {
        document.getElementById('inmap-location-control').remove();
      }
    },
    initializeMap(gmSettings) {
      gmSettings.fullscreenControl = {
        position: this.gmaps.google.maps.ControlPosition.LEFT_CENTER
      };

      gmSettings.mapTypeControlOptions = {
        style: this.gmaps.google.maps.MapTypeControlStyle.HORIZONTAL_BAR, // DROPDOWN_MENU / HORIZONTAL_BAR / DEFAULT
        position: this.gmaps.google.maps.ControlPosition.TOP_LEFT
      };

      this.gmaps.map = new this.gmaps.google.maps.Map(
        document.getElementById('map'),
        gmSettings
      );

      if (
        this.$route.params.lat &&
        this.$route.params.lng &&
        this.$route.params.zoom &&
        this.$route.params.mapTypeId
      ) {
        this.gmaps.map.setCenter({
          lat: parseFloat(this.$route.params.lat),
          lng: parseFloat(this.$route.params.lng)
        });
        this.gmaps.map.setZoom(parseFloat(this.$route.params.zoom));
        this.gmaps.map.setMapTypeId(this.$route.params.mapTypeId);
      }

      this.gmaps.map.addListener('click', (event) => {
        this.clearBboxPaths();
        this.$store.dispatch('general/mapClicked', event);
      });

      this.gmaps.map.addListener('dragend', () => {
        this.updateMapCenterInURL();

        this.clearBboxPaths();
      });

      this.gmaps.map.addListener('bounds_changed', () => {
        if (this.overlay) {
          this.overlay.setMap(null);
        }
        if (this.general.showCadastralLayer) {
          this.getCadastralLayer();
        }
      });

      // Update map center on move (when centering to given pin etc.)
      let moving = false;
      let baseThis = this;
      this.gmaps.map.addListener('center_changed', () => {
        moving = true;
      });
      setInterval(function () {
        if (moving) {
          moving = false;
          baseThis.updateMapCenterInURL();
        }
      }, 3000);

      this.gmaps.map.addListener('zoom_changed', () => {
        let obj = {
          ...this.$route.query
        };

        let params = {
          ...this.$route.params
        };
        params.zoom = this.gmaps.map.getZoom();

        let mapCenter = this.gmaps.map.getCenter();
        params.lat = mapCenter.lat();
        params.lng = mapCenter.lng();

        this.$router
          .replace({ name: 'base', params: params, query: obj })
          .catch((err) => {});

        this.clearBboxPaths();

        if (this.overlay) {
          this.overlay.setMap(null);
        }

        if (this.general.showCadastralLayer) {
          this.getCadastralLayer();
        }
      });
      this.gmaps.map.addListener('maptypeid_changed', () => {
        let obj = {
          ...this.$route.query
        };

        let params = {
          ...this.$route.params
        };
        params.mapTypeId = this.gmaps.map.getMapTypeId();

        this.$router
          .replace({ name: 'base', params: params, query: obj })
          .catch((err) => {});
      });

      this.gmaps.google.maps.event.addListenerOnce(
        this.gmaps.map,
        'idle',
        () => {
          this.mapLoaded = true;
        }
      );

      if (this.general.enableGeolocation) {
        this.addCurrentLocationControl();
      }
    },

    initializeInfowindow() {
      let infowindow = new this.gmaps.google.maps.InfoWindow({
        content: ''
      });
      this.$store.dispatch('general/setInfowindow', infowindow);
    },

    openNewComment() {
      this.$store.dispatch('general/setLayoutOption', ['newComment', true]);
    },

    openNewPin(layerId) {
      this.$store.dispatch('general/setLayoutOption', ['newPin', true]);
      this.$store.dispatch('general/setNewPinLayerId', layerId);
    },

    getCadastralLayer() {
      let CadastralOverlay = class {
        constructor(bounds, image, map) {
          this.bounds_ = bounds;
          this.image_ = image;
          this.map_ = map;
          this.div_ = null;

          // Explicitly call setMap on this overlay.
          this.setMap(map);
        }
      };

      CadastralOverlay.prototype = new this.gmaps.google.maps.OverlayView();

      /**
       * onAdd is called when the map's panes are ready and the overlay has been
       * added to the map.
       */
      CadastralOverlay.prototype.onAdd = function () {
        var div = document.createElement('div');
        div.style.borderStyle = 'none';
        div.style.borderWidth = '0px';
        div.style.position = 'absolute';

        // Create the img element and attach it to the div.
        var img = document.createElement('img');
        img.src = this.image_;
        img.style.position = 'absolute';
        div.appendChild(img);

        this.div_ = div;

        // Add the element to the "overlayLayer" pane.
        var panes = this.getPanes();
        panes.overlayLayer.appendChild(div);
      };

      CadastralOverlay.prototype.draw = function () {
        // We use the south-west and north-east
        // coordinates of the overlay to peg it to the correct position and size.
        // To do this, we need to retrieve the projection from the overlay.
        var overlayProjection = this.getProjection();

        // Retrieve the south-west and north-east coordinates of this overlay
        // in LatLngs and convert them to pixel coordinates.
        // We'll use these coordinates to resize the div.
        var sw = overlayProjection.fromLatLngToDivPixel(
          this.bounds_.getSouthWest()
        );
        var ne = overlayProjection.fromLatLngToDivPixel(
          this.bounds_.getNorthEast()
        );

        // Resize the image's div to fit the indicated dimensions.
        var div = this.div_;
        div.style.left = sw.x + 'px';
        div.style.top = ne.y + 'px';
        div.style.width = ne.x - sw.x + 'px';
        div.style.height = sw.y - ne.y + 'px';
      };

      // The onRemove() method will be called automatically from the API if
      // we ever set the overlay's map property to 'null'.
      CadastralOverlay.prototype.onRemove = function () {
        this.div_.parentNode.removeChild(this.div_);
        this.div_ = null;
      };

      let bounds = this.gmaps.map.getBounds();
      let NE = bounds.getNorthEast();
      let SW = bounds.getSouthWest();

      let degrees2meters = (lat, lng) => {
        var x = (lng * 20037508.34) / 180;
        var y =
          Math.log(Math.tan(((90 + lat) * Math.PI) / 360)) / (Math.PI / 180);
        y = (y * 20037508.34) / 180;
        return { x: x, y: y };
      };

      const width = document.webkitIsFullScreen
        ? window.screen.width
        : this.gmaps.map.getDiv().offsetWidth;

      const height = document.webkitIsFullScreen
        ? window.screen.height
        : this.gmaps.map.getDiv().offsetHeight;

      let data = {
        ne: degrees2meters(NE.lat(), NE.lng()),
        sw: degrees2meters(SW.lat(), SW.lng()),
        width: width,
        height: height
      };
      let cadastralOverlayImage = CUZKDataService.getCadastralOverlayImage(
        data
      );
      this.overlay = new CadastralOverlay(
        bounds,
        cadastralOverlayImage,
        this.gmaps.map
      );
    },

    clearBboxPaths() {
      this.$store.dispatch('general/destroyBBoxPaths');
    }
  },
  watch: {
    'general.showCadastralLayer'(newValue) {
      if (!this.mapLoaded) {
        return;
      }

      if (newValue) {
        this.getCadastralLayer();

        let obj = {
          ...this.$route.query
        };

        obj.katastr = 1;

        this.updateBaseUrl(obj);
      } else {
        this.overlay.setMap(null);
        this.clearBboxPaths();

        let obj = {
          ...this.$route.query
        };

        obj.katastr = 0;

        this.updateBaseUrl(obj);
      }
    },
    'general.enableGeolocation'(enabled) {
      if (enabled) {
        this.addCurrentLocationControl();
      } else {
        this.removeCurrentLocationControl();
      }
    }
  }
};
</script>

<style>
.btn--dropdown {
  box-shadow: none;
  min-height: 30px;
}

.btn--dropdown:hover {
  box-shadow: none;
}
</style>
<style scoped>
.map-wrap {
  display: flex;
  flex-grow: 1;
  position: relative;
}

.btn--inMap {
  position: absolute;
  top: 10px;
  margin-left: auto;
  margin-right: auto;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  /*right: 0;*/
  z-index: 1;
  /* max-width: 240px; */
}

.btn--inMap-toggle {
  left: 242px;
  top: 10px;
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  /*right: 0;*/
  z-index: 1;
  max-width: 240px;
  background: white;
  padding: 10px;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
}

@media (max-width: 1500px) {
  .btn--inMap {
    top: auto;
    bottom: 10px;
  }
}
.inmap-switches {
  position: absolute;
  top: 55px;
  left: 10px;
  z-index: 1;
}
#map {
  /*width: 95vw;
  height: 80vh;*/
  width: 100%;
  height: 100%;
  flex-grow: 1;
}
</style>
